<template>
  <div class="queryContent zmquery">
    <div class="query-header scroll-border-dom">
      <div class="query-header-wrap">
        <div class="query-slogon">
          {{$t('query.result.other.zmAddTariffQuery')}}
          <span style="font-weight:bold;">（本查询已更新至<span style="color:#ea2c2c;">2019年6月1日</span>最新的中美加征清单）</span>
          <span style="color:#E02E24;font-size:12px;display:none;" v-if="$i18n.locale === 'zh-CN' && apiPrice && apiPrice(4).integral === 0">（限时免费）</span>
        </div>
        <div class="query-inputs">
          <div class="inputs clearfix">
            <div class="country-input search-input-item">
              <div class="export-input">
                <span v-if="type === 1">中国</span>
                <span v-else>美国</span>
              </div>
              <div class="bi_arrow" @click="type= type === 1? 2 : 1">
                <img src="~@/assets/images/icons/search/bi_arrow.png">
              </div>
              <div class="import-input">
                <span v-if="type === 1">美国</span>
                <span v-else>中国</span>
              </div>
            </div>
            <div class="hscode search-input-item">
              <Input class="input" type="text" v-model.trim="code" :placeholder="placeholderText" @on-enter="searchHandle" />
            </div>
          </div>
          <div class="btn-wrap clearfix">
            <Button type="primary" class="btn search" :loading="isShowLoader" @click.prevent="searchHandle">
              <span v-if="!isShowLoader"><span>{{$t('btn.search')}}</span></span>
              <span v-else>{{$t('common.loading')}}</span>
            </Button>
            <Button class="btn reset" type="primary" @click.prevent="resetHandle" :disabled="isShowLoader"><span>{{$t('btn.reset')}}</span></Button>
          </div>
        </div>
      </div>
    </div>
    <div class="results">
      <div class="shadow-divide"></div>
      <div class="results-wrap">
        <div class="results-content">
          <ListContent class="r-main" :dataSet="dataSet"></ListContent>
        </div>
      </div>
      <Loader :loadType="1" v-show="isShowLoader" class="black"></Loader>
    </div>
  </div>
</template>

<script>
import ListContent from './ListContent'
import Loader from '../layout/Loader'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapDataState, mapGetters: mapDataGetters } = createNamespacedHelpers('data')

export default {
  name: 'ZMTariffQueryList',
  components: { ListContent, Loader },
  data () {
    return {
      isShowLoader: false,
      dataSet: {},
      type: 1,
      code: ''
    }
  },
  computed: {
    placeholderText () {
      // if (this.type === 1) {
      //   return '请输入美国进口申报税号 / 中国出口申报税号查询'
      // } else {
      //   return '请输入中国进口申报税号 / 美国出口申报税号查询'
      // }
      return '请输入中国进出口税号'
    },
    apiPrice () {
      if (this._.isEmpty(this.apiValue)) {
        return null
      } else {
        return this.getApiValue()
      }
    },
    ...mapDataState({
      apiValue: state => state.apiValue
    })
  },
  mounted () {
    this.$nextTick(() => {
      this.setContentHeight()
    })
  },
  methods: {
    searchHandle () {
      if (!this.code) {
        this.$Message.warning({content: this.$t('query.message.input_tariff_empty'), closable: true})
      } else {
        this.jfNotice2()
      }
    },
    jfNotice2 () {
      if (this.$i18n.locale === 'zh-CN') {
        this.GJFNotice(status => {
          if (status) {
            let jf = this.getApiValue()(4)
            if (jf && jf.integral && jf.integral > 0) {
              this.GConfirm(`本次查询将消耗${jf.integral}积点，当天重复查询不再扣除积点。`, status => {
                if (status) {
                  this.requestData()
                }
              })
            } else {
              this.requestData()
            }
          } else {
            this.requestData()
          }
        })
      } else {
        this.requestData()
      }
    },
    resetHandle () {
      this.code = ''
    },
    requestData () {
      if (this.isShowLoader) return
      this.$Loading.start()
      this._h.scrollTop()
      this.isShowLoader = true
      this.$api.zmTariffQuery.get({type: this.type, code: this.code}, {
        success: (response) => {
          this.$Loading.finish()
          if (response.data.code === 200) {
            if (response.data.data) {
              this.dataSet = response.data.data
            } else {
              this.dataSet = {type: this.type, cnCode: this.code, usCode: this.code, levy: 0}
            }
          } else if (response.data.code === 404) {
            this.dataSet = {type: this.type, cnCode: this.code, usCode: this.code, levy: 0}
            // this.$Message.warning({content: this.$t('query.message.input_tariff_error'), closable: true})
          } else if (response.data.code === 505) {
            this.dataSet = {}
            this.GMessage('warning', this.$t('query.message.search_frequent'), '去充值', { name: 'Recharge' })
            // this.$Notice.info({
            //   desc: this.$t('query.message.search_frequent'),
            //   duration: 0
            // })
          } else if (response.data.code === 401) {
            this.dataSet = {}
            this.GMessage('warning', this.$t('query.message.search_perm_limit2'), '登录', { path: '/my' })
          } else if (response.data.code === 506) {
            this.GMessage('warning', this.$t('query.message.search_perm_limit'), '登录', { path: '/my' })
          } else {
            this.dataSet = {}
            this.$Message.warning({content: this.$t('query.message.input_tariff_iorrect'), closable: true})
          }
          this.isShowLoader = false
        },
        error: (errorMsg) => {
          this.isShowLoader = false
          this.dataSet = {}
          this.$Message.error({content: this.$t('common.tryAgain'), closable: true})
          this.$Loading.error()
        }
      })
    },
    setContentHeight () {
      let resultDom = document.querySelector('.results')
      let footer = document.querySelector('footer')
      let resultMinHeight = (this._h.getWinHeight() - Math.abs(this._h.getScrollTop() - Math.abs(this._h.getOffset(resultDom).top) - this._h.getOuterElSize(footer).height - 18))
      resultDom.style.minHeight = resultMinHeight + 'px'
    },
    ...mapDataGetters([
      'getApiValue'
    ])
  }
}
</script>
<style scoped>
  .results{
    position: relative;
    padding: 15px 0 25px;
  }
  .queryContent .query-header-wrap,
  .results-wrap{
    width:1400px;
    margin: 0 auto;
    padding-bottom: 20px;
  }
  .query-slogon{
    margin: 25px 0 10px;
    color: #333;
    padding-left: 1px;
  }
  .query-inputs{
    position: relative;
    padding-left: 1px;
  }
  .query-inputs .inputs{
    width: 65%;
    position: relative;
    padding-left: 280px;
  }
  .query-inputs .country-input{
    position: absolute;
    top: 0;
    left: 0;
    width: 280px;
    height: 34px;
    border: 1px solid #ddd;
    background-color: #fff;
    border-right: 0 none;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
  }
  .query-inputs .country-input .export-input,
  .query-inputs .country-input .import-input{
    position: absolute;
    width: 50%;
    top: 0;
    left: 0;
    padding-left: 24px;
    background: url("~@/assets/images/icons/search/export.png") 10px center no-repeat transparent;
    background-size: 8px;
    color: #333;
    height: 32px;
    line-height: 32px;
  }
  .query-inputs .country-input .import-input{
    background-image: url("~@/assets/images/icons/search/import.png");
    left: 50%;
  }
  .query-inputs .country-input .bi_arrow{
    position: absolute;
    top:0;
    bottom: 0;
    height: 100%;
    left: 36%;
    width: 12px;
    transform: translateX(-50%);
    cursor: pointer;
  }
  .query-inputs .country-input .bi_arrow img{
    width: 100%;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
  .query-inputs .hscode.search-input-item{
    /*border: 1px solid #ddd;*/
    background-color: #fff;
    /*height: 34px;*/
    /*border-top-right-radius: 3px;*/
    /*border-bottom-right-radius: 3px;*/
  }
  .query-inputs .hscode.search-input-item >>> .ivu-input{
    /*border: 0 none;*/
    /*border-radius: 0;*/
    height: 34px;
    line-height: 34px;
    /*border-top-left-radius: 0;*/
    /*border-bottom-left-radius: 0;*/
    /*border-top-right-radius: 3px;*/
    /*border-bottom-right-radius: 3px;*/
    border-radius: 0 3px 3px 0;
    border-color: #ddd;
    outline: 0 none;
    padding-left: 24px;
    background: url("~@/assets/images/icons/search/product.png") 10px center no-repeat transparent;
    background-size: 9px;
  }
  .query-inputs .hscode.search-input-item >>> .ivu-input:focus{
    border-color: #ddd;
    outline: 0;
    box-shadow: none;
    background-image: url("~@/assets/images/icons/search/product_active.png");
  }
  .btn-wrap{
    position: absolute;
    top:0;
    left: 65%;
    height: 100%;
    margin-left: 8px;
  }
  .btn{
    width: 110px;
    border: 1px solid #1F8AFD;
    border-radius: 3px;
    height: 100%;
    float: left;
    /*font-size: 12px;*/
    font-size: 14px;
    text-align: center;
    cursor: pointer;
    position: relative;
  }
  .btn span{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .btn.search{
    background-color: #1F8AFD;
    color: #fff;
  }
  .btn.ivu-btn-loading{
    cursor: default;
  }
  .btn.ivu-btn-loading span{
    position: static;
    transform: none;
  }
  .btn.reset{
    background-color: #fff;
    color: #1F8AFD;
    margin-left: 8px;
  }
  .btn.reset[disabled]{
    color: #bbbec4;
    /*background-color: #f7f7f7;*/
    border-color: #dddee1;
    cursor: default;
  }
  .shadow-divide{
    position: absolute;
    top:0;
    left:0;
    width: 100%;
    box-shadow: 0 2px 4px 0 rgba(223,223,223,0.50);
    z-index: 1;
    height: 5px;
    background-color: #fff;
  }
  .results-content{
    position: relative;
    /*padding-left: 245px;*/
  }
  .zmquery .breadcrumbs{
    font-size: 13px;
  }
  .zmquery .query-slogon{
    font-size: 13px;
  }
  .zmquery .query-inputs{
    font-size: 13px;
  }
  .r-main{}
</style>




// WEBPACK FOOTER //
// src/components/zmTariffQuery/List.vue